function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome1Tl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 428,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M699.776-159.52c-4.336 9.55-15.511 64.043-199.849 290.719C386.559 270.604 140.008 377.994-53.458 416.061c-121.113 23.831-200.762 1.37-277.869 1.795 57.869-102.549 133.409-196.064 227.492-289.35C31.671-5.85 199.494-104.738 248.887-125.327c83.688-34.885 455.225-43.744 450.889-34.193Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome1Tl);
export default __webpack_public_path__ + "static/media/bg_home1_tl.b51a8ea5f1d5e0b6e44da00c2e299ee0.svg";
export { ForwardRef as ReactComponent };